import "./footer.css";
import { Link } from "react-router-dom";
import logo from "../../assets/img/logo.svg";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";

const Footer = () => {
	return (
		<footer>
			<div className="container">
				<div className="footer-main-content">
					<div className="box">
						<Link className="logo">
							<img src={logo} alt="logo-img" />
						</Link>
						<p className="desc">Mobile Pflege Petker GmbH & Co. KG</p>
						<p className="desc">Auf den Ängern 5 34439 Willebadessen</p>
						<ul className="links">
							<li>
								<a href="tel:05646 943182">
									<i className="icon">
										<LocalPhoneIcon />
									</i>
									05646 943182
								</a>
							</li>
							<li>
								<a href="meilto:info@mobilepflege-petker.de">
									<i className="icon">
										<EmailIcon />
									</i>
									info@mobilepflege-petker.de
								</a>
							</li>
						</ul>
					</div>
					<div className="box">
						<h3 className="title">Firma</h3>
						<ul className="links">
							<li>
								<Link>Home</Link>
							</li>
							<li>
								<Link>Über uns</Link>
							</li>
							<li>
								<Link>Kontakt</Link>
							</li>
							<li>
								<Link>FAQ</Link>
							</li>
						</ul>
					</div>
					<div className="box">
						<h3 className="title">Leistungen</h3>
						<ul className="links">
							<li>
								<Link>Pflegeberatung</Link>
							</li>
							<li>
								<Link>Mobile Pflege</Link>
							</li>
							<li>
								<Link>Kontakt</Link>
							</li>
							<li>
								<Link>Tagespflege</Link>
							</li>
							<li>
								<Link>Wohngruppe</Link>
							</li>
						</ul>
					</div>
					<div className="box">
						<h3 className="title">Karriere</h3>
						<ul className="links">
							<li>
								<Link>Jobs</Link>
							</li>
							<li>
								<Link>Ausbildung</Link>
							</li>
							<li>
								<Link>Bewerbungsportal</Link>
							</li>
						</ul>
					</div>
				</div>
				<div className="footer-bottom-content">
					<p className="copyright">
						Copyright &copy; 2023 <strong>Mobile Pflege Petker</strong> - Made
						with ♡ by Ibrahim
					</p>
					<a href="/" className="datenschutz">
						Impressum | Datenschutz
					</a>
					<ul className="links">
						<li>Folgen Sie uns</li>
						<li>
							<a href="fb.com">
								<FacebookOutlinedIcon />
							</a>
						</li>
						<li>
							<a href="insta.com">
								<InstagramIcon />
							</a>
						</li>
					</ul>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
